import React from "react";
import { motion } from "framer-motion";
import { fadeUp } from "../../animations/variants";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import CTAButton from "Util/CTAButton";
import { Info, LayoutDashboard, Phone, PhoneCall } from "lucide-react";
import { discussMaria } from "i18n/Insight";

const DiscussMaria = () => {
  const navigate = useNavigate();

  const lang = useSelector((state) => state.language.lang);
  const t = discussMaria[lang];

  return (
    <section className="relative overflow-hidden py-20 lg:py-28 bg-[#0d0d0d]">
      <div className="absolute inset-0 overflow-hidden">
        <div className="absolute top-0 left-1/4 w-96 h-96 bg-reddark/10 rounded-full blur-[120px]" />
        <div className="absolute bottom-0 right-1/4 w-96 h-96 bg-red-500/10 rounded-full blur-[120px]" />
      </div>

      <div className="relative z-10 max-w-6xl mx-auto px-3">
        <motion.div
          variants={fadeUp}
          initial="hidden"
          whileInView="show"
          viewport={{ once: true }}
          className="
        relative
        rounded-[32px]
        border border-white/10
        bg-white/[0.03]
        backdrop-blur-xl
        p-10 md:p-16
        text-center
        overflow-hidden
      "
        >
          <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-reddark via-red-500 to-reddark" />

          {/* <motion.div
            variants={fadeUp}
            initial="hidden"
            whileInView="show"
            viewport={{ once: true }}
            className="flex items-center justify-center gap-4 mb-6"
          >
            <span className="w-12 h-px bg-reddark" />
            <span className="uppercase tracking-[0.3em] text-sm text-white/80 font-medium">
              MARIA'S PERSPECTIVE
            </span>
            <span className="w-12 h-px bg-reddark" />
          </motion.div> */}
          {/* Title */}
          <div className="max-w-5xl mx-auto">
            <div className="flex items-center justify-center gap-5 mb-10">
              <span className="w-12 h-px bg-reddark" />

              <img
                src="/maria/maria3.png"
                alt="Maria"
                className="
      w-40 h-40
      rounded-full
      border-2 border-reddark
      object-cover
      bg-white
    "
              />

              <span className="w-12 h-px bg-reddark" />
            </div>

            <blockquote
              className="
      -mt-6
      text-white
      text-2xl md:text-4xl lg:text-5xl
      font-[Crimson]
      italic
      leading-tight
      max-w-5xl
      mx-auto
      mb-8
    "
            >
              {t.quote}
            </blockquote>

            <div className="text-center">
              <div className="text-reddark text-xl md:text-2xl font-semibold">
                — {t.name} —
              </div>

              <div className="text-white/60 mt-2">{t.role}</div>
            </div>
          </div>
          {/* Subtitle */}
          <p
            className="
          max-w-3xl
          mx-auto
          text-lg md:text-xl
          text-white/70
          leading-relaxed
          mb-12
        "
          >
            {t.subtitle}
          </p>
          <motion.div
            variants={fadeUp}
            initial="hidden"
            whileInView="show"
            viewport={{ once: true }}
            className="w-24 h-1 bg-reddark rounded-full mb-8 mx-auto"
          />
          <CTAButton
            variant="primary"
            icon={PhoneCall}
            text={t.button1}
            onClick={() => navigate("/contact")}
          />
        </motion.div>
      </div>
    </section>
  );
};

export default DiscussMaria;
